module.exports = __webpack_public_path__ + "static/img/backgroundNewC.a0e34167.jpg";